import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'my-degree-simple-progress-bar',
    templateUrl: './my-degree-simple-progress-bar.component.html',
    styleUrls: ['./my-degree-simple-progress-bar.component.scss'],
    standalone: false
})
export class MyDegreeSimpleProgressBarComponent implements OnInit {
    @Input() complete: number;
    public percentBarStyle: string;

    constructor() { }

    public ngOnInit(): void {
        //  We normally wouldn't define the styling here, but because there is math involved and it's a bit long/complicated
        //  this was a better place to handle this than in the HTML.  
        let barColor = this.complete < 50 ? 'var(--warning-light)' : 'var(--unc-blue)';
        this.percentBarStyle = `linear-gradient(to right, ${barColor} ${this.complete}%, var(--secondary-light) ${this.complete}%)`;
    }

}
